import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import BackMethods from "../../back_component/BackMethods";

export default function EditRolePage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();

    const [role, setRole] = useState({
        displayName: "",
        description: "",
        permissionIds: [],
    });

    const [permissions, setPermissions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formError, setFormError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");

    //  جلب بيانات الدور + جميع الصلاحيات
    useEffect(() => {
        const fetchData = async () => {
            try {
                const [roleRes, permsRes] = await Promise.all([
                    backEnd_request.get(`/admin/Roles/${id}`),
                    backEnd_request.get(`/admin/Permissions`),
                ]);

                const roleData = roleRes.data;
                const permsData = permsRes.data;

                setRole({
                    displayName: roleData.displayName || "",
                    description: roleData.description || "",
                    permissionIds: roleData.permissions.map((p) => p.permissionId),
                });
                setPermissions(permsData);
            } catch (error) {
                console.error("❌ خطأ في جلب البيانات:", error.response?.data || error);
                setFormError("حدث خطأ أثناء تحميل بيانات الدور");
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, [id]);

    //  تحديث القيم
    const handleChange = (field, value) => {
        setRole((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    //  تغيير حالة checkbox
    const handlePermissionToggle = (permissionId) => {
        setRole((prev) => {
            const exists = prev.permissionIds.includes(permissionId);
            return {
                ...prev,
                permissionIds: exists
                    ? prev.permissionIds.filter((id) => id !== permissionId)
                    : [...prev.permissionIds, permissionId],
            };
        });
    };

    // 🔎 تحقق
    const validate = () => {
        if (!role.displayName.trim()) return "الرجاء إدخال الاسم المعروض";
        return "";
    };

    //  إرسال الطلب
    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormError("");
        setSuccessMessage("");

        const error = validate();
        if (error) {
            setFormError(error);
            return;
        }

        setIsSubmitting(true);
        try {
            const payload = {
                displayName: role.displayName,
                description: role.description,
                permissionIds: role.permissionIds,
            };

            await backEnd_request.post(`/admin/Roles/${id}`, payload);
            setSuccessMessage("تم تعديل الدور بنجاح!");
            setTimeout(() => navigate("/admin/roles-management"), 1500);
        } catch (err) {
            console.error(err.response?.data || err);
            setFormError(err.response?.data?.message || "حدث خطأ أثناء تعديل الدور");
        } finally {
            setIsSubmitting(false);
        }
    };

    if (isLoading) {
        return (
            <div className="text-center text-light py-5">
                <h3>جاري تحميل بيانات الدور...</h3>
            </div>
        );
    }

    return (
        <div className="bg-dark min-vh-100 d-flex align-items-center py-5">
            <div className="container">
                <div className="text-center mb-5">
                    <h1
                        className="text-light fw-bold"
                        style={{ fontSize: "2.3rem", letterSpacing: "1px" }}
                    >
                        تعديل الدور
                    </h1>
                    <p className="text-light" style={{ fontSize: "1.1rem" }}>
                        يمكنك تعديل معلومات الدور والصلاحيات المرتبطة به
                    </p>
                </div>

                <div className="d-flex justify-content-center">
                    <div
                        className="card border-0 shadow-lg"
                        style={{
                            width: "100%",
                            maxWidth: "800px",
                            borderRadius: "20px",
                        }}
                    >
                        <div
                            className="card-header text-center py-4"
                            style={{
                                backgroundColor: "#f8f9fa",
                                borderTopLeftRadius: "20px",
                                borderTopRightRadius: "20px",
                            }}
                        >
                            <h3 className="text-dark m-0 fw-bold">معلومات الدور</h3>
                        </div>

                        <div className="card-body bg-white p-5 rounded-bottom">
                            <form onSubmit={handleSubmit}>
                                <div className="row g-3 mb-3">
                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control p-3"
                                            placeholder="الاسم المعروض"
                                            value={role.displayName || ""}
                                            onChange={(e) => handleChange("displayName", e.target.value)}
                                            style={{ borderRadius: "12px" }}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control p-3"
                                            placeholder="الوصف"
                                            value={role.description || ""}
                                            onChange={(e) => handleChange("description", e.target.value)}
                                            style={{ borderRadius: "12px" }}
                                        />
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <h5 className="fw-bold mb-3">الصلاحيات:</h5>
                                    <div
                                        className="p-3 border rounded"
                                        style={{
                                            maxHeight: "300px",
                                            overflowY: "auto",
                                            borderRadius: "12px",
                                        }}
                                    >
                                        {permissions.map((perm) => (
                                            <div key={perm.permissionId} className="form-check mb-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id={`perm-${perm.permissionId}`}
                                                    checked={role.permissionIds.includes(perm.permissionId)}
                                                    onChange={() => handlePermissionToggle(perm.permissionId)}
                                                />
                                                <label
                                                    className="form-check-label ms-2"
                                                    htmlFor={`perm-${perm.permissionId}`}
                                                >
                                                    {perm.displayName}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="mt-4">
                                    <button
                                        type="submit"
                                        className={`btn w-100 py-3 fw-bold ${isSubmitting ? "btn-secondary" : "btn-dark text-light"
                                            }`}
                                        style={{ borderRadius: "12px", fontSize: "1.1rem" }}
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? "جارٍ الحفظ..." : "حفظ التغييرات"}
                                    </button>
                                </div>

                                {formError && (
                                    <div className="text-danger text-center mt-3 fw-bold">
                                        {formError}
                                    </div>
                                )}
                                {successMessage && (
                                    <div className="text-success text-center mt-3 fw-bold">
                                        {successMessage}
                                    </div>
                                )}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
